export default {
  startRecording: 'Iniciar Grabación',
  stopRecording: 'Detener Grabación',
  recordAgain: 'Grabar de nuevo',
  denied: 'Diga su respuesta en voz alta.',
  deniedNotice: 'My Move no puede acceder a su micrófono. Es posible que la configuración de su navegador lo esté bloqueando.',
};
